export const handleConvertFormDataToObject = <T>(formData: FormData) => {
  let data = {};
  const keys = formData.keys();
  for (const key of keys) {
    data = { ...data, [key]: formData.get(key) };
  }
  return data as T;
};

export const handleConvertObjectToFormData = (object: {
  [key: string]: any;
}) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    formData.append(key, object[key as keyof typeof object]);
  });
  return formData as FormData;
};
